// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__LOU5w","insightsList":"newBusinessInsightsMenu_insightsList__2zz7q","active":"newBusinessInsightsMenu_active__2bwgx"};